// extracted by mini-css-extract-plugin
export default {"dialog":"cardMessage_dialog__PYDGr","card":"cardMessage_card__rRy7n","content":"cardMessage_content__KsKKH","close":"cardMessage_close__2EPNg","icon":"cardMessage_icon__5ggxm"};